/**
* Created By: Jennifer Mancilla
* Creation Date: 08/09/2022
* PBI: 78282 - Landing Bienvenida Cotizador Bepensa
*
* Last Modifier:
* Last Modification: 
*
* Feat: 
*
* version: 1.0.0
* copyright: 2022 INDUSTRIAS RESSER S.A DE C.V
*/
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { DimensionsState } from '../../../interfaces/commonInterfaces';

const initialState: DimensionsState = {
    width: window.innerWidth,
    height: window.innerHeight
};

export const dimensionsSlice = createSlice({
    name: 'dimensions',
    initialState,
    reducers: {
        getDimensions: (state: DimensionsState, action: PayloadAction<Window & typeof globalThis>) => {
            state.width = action.payload.innerWidth;
            state.height = action.payload.innerHeight;
        },
    },
});

export const { getDimensions } = dimensionsSlice.actions;